let Banner = (() => {

    let init = () => {
        bindClick();
    }

    let bindClick = () => {
        jQuery(document).on('click', '#banner-close-icon', () => {
            jQuery(this).closest('#banner-wrapper').hide();
            Util.setCookie('hide_banner', true, .0417); // 1/24 = .0417 to represent 1 hour (1/24th of a day)
        });
    }
    return {
        init: init,
    }
})();